<template>
  <iframe ref="emr" seamless :src="url" width="100%" height="99%" style="border: none"></iframe>
</template>
<script>
import { mapGetters } from "sw-hic";

// window.addEventListener("message", (e) => {
//   setTimeout(function () {
//     if (e.data.event == "mrMain") {
//       updateTreatment(e.data.data);
//     }
//   }, 1000);
// });

export default {
  props: {
    entity: Object,
    display: Boolean,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["token", "user", "setting"]),
    readonly() {
      return this.entity?.state == "已离院" || this.entity?.state == "已结算";
    },
    url() {
      let url = `${this.setting.emrServer}/#/studio?ip=${this.entity.ipNo}&dept=${this.user.deptCode}&token=${this.token}`
      // let url = `http://localhost:9090/#/studio?ip=${this.entity.ipNo}&dept=${this.user.deptCode}&token=${this.token}`;
      if (this.readonly) {
        url += "&readonly=true";
      }
      this.$utils.log("emr url", url);
      return url;
    }
  },
  watch: {
    entity() {
      if (!this.display) {
        return;
      }
      // 切换用户前暂存病历
      this.save();
      this.$nextTick(() => {
        this.$refs.emr.contentWindow.postMessage({ event: "refresh", data: this.entity.ipNo }, "*");
      });
    },
  },

  mounted() {
    if (!this.display) {
      return;
    }
  },
  methods: {
    save() {
      this.$utils.log("send save command");
      this.$refs.emr.contentWindow.postMessage({ event: "save", data: false }, "*");
      this.$refs.emr.contentWindow.postMessage({ event: "unlock", data: null }, "*");
    },
  },
};
</script>
